export {
    Type,
    JSON,
    instanceOf,
    fromCBOR,
    parse,
    toCBOR,
    fromAny,
    fromString,
    registerCBORDecoder,
    registerCBOREncoder,
} from '../../plt/CborMemo.js';
